import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { HeroBannerWrapper } from '../layouts/HeroBannerWrapper/HeroBannerWrapper';
import { ReferenceCardSection } from '../layouts/ReferenceCardSection/ReferenceCardSection';
import { InfoSection } from '../layouts/InfoSection/InfoSection';
import { ButtonWithContentWrapper } from '../layouts/ButtonWithContentWrapper/ButtonWithContentWrapper';
import { BackToTop } from '../components/BackToTop/BackToTop';
import { Loader } from '../components/Loader/Loader';
import { ButtonTabs } from '../components/ButtonTabs/ButtonTabs';
import { Breadcrumb } from '../components/Breadcrumb/Breadcrumb';
import { BrandUtil, useContentfulPreview, wineryDirectStates } from 'dw-us-ui';
import { ProductListing } from '../layouts/ProductListing/ProductListing';
import { BeyondTheLabel } from '../layouts/BeyondTheLabel/BeyondTheLabel';
import { StandardContentBlockWrapper } from '../layouts/StandardContentBlockWrapper/StandardContentBlockWrapper';
import { BlogImageContent } from '../components/BlogImageContent/BlogImageContent';
import { MultipleBlogImageContent } from '../components/MultipleBlogImageContent/MultipleBlogImageContent';
import { PromoStripWrapper } from '../layouts/PromoStripWrapper/PromoStripWrapper';
import { ReactHelmet } from '../components/ReactHelmet/ReactHelmet';
const contentful = require(`contentful`);

const BlogMainContainer = styled.div`
  font-size: 16px;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: revert;
    font-family: revert;
    line-height: normal;
    font-weight: revert;
    margin: revert;
  }
  ol,
  ul {
    list-style: revert;
    padding-left: 20px;
  }
  p {
    margin: revert;
  }

  table {
    border-collapse: collapse;
    width: 100%;
  }
  table tr:first-child {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  table tr:last-child {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  th,
  td {
    padding-left: 10px;
    text-align: center;
    border: 1px solid #ddd;
  }
  th {
    background-color: #f2f2f2;
    color: #333;
    font-weight: bold;
  }
  @media (max-width: 600px) {
    table {
      width: 100%;
      font-size: 14px;
    }
    <<<<<<< HEAD =======>>>>>>>3533b75d01d1ca3fadd88eceb511416a4b7000e4 th,
    td {
      padding-left: 10px;
    }
  }
`;

const HomePage = ({ pathName }) => {
  const [isLoading, setLoading] = useState(true);
  const [contentfulData, setContentfulData] = useState();
  const brand = BrandUtil.getBrand();
  const brandTag = BrandUtil.content(brand).tag.toLowerCase();
  const { isPreview, sysId } = useContentfulPreview('hub_page_preview');

  let host, accessToken;

  if (isPreview) {
    accessToken = 'C4twFy9_lOdTcwrqh2yloRwl-TpH_VwcZE0sgiqVU1M';
    host = 'preview.contentful.com';
  } else {
    accessToken = 'wvjyW-zr51YWLmFHfHAyq8hYqwIQC2OuaJFuMl8xKrw';
    host = 'cdn.contentful.com';
  }

  const client = contentful.createClient({
    space: 'k1ni6e3k3b2n',
    accessToken,
    host: host,
    environment: 'master',
  });
  let lastPathName = location.pathname.substring(location.pathname.lastIndexOf('/') + 1);

  const resolveResponse = response => {
    setContentfulData(response.items[0].fields);
    setLoading(false);
  };

  const resolveError = error => {
    setLoading(false);
  };

  const additionalFilters = {
    'fields.slug': lastPathName,
    'fields.brand': brandTag.toUpperCase(),
    'fields.wd': wineryDirectStates.includes(pageLayer[0].stateCode),
  };
  if (sysId?.length) {
    additionalFilters['sys.id'] = sysId;
  }

  const contentfulQuery = {
    content_type: 'hubPage',
    include: '4',
    ...additionalFilters,
  };
  useEffect(() => {
    setLoading(true);
    client
      .getEntries(contentfulQuery)
      .then(entriesResponse => resolveResponse(entriesResponse))
      .catch(entriesError => resolveError(entriesError));
  }, [pathName]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);
  const getComponentName = items => {
    const { fields, sys } = items;
    const type = fields?.module || sys?.contentType?.sys?.id;
    switch (type) {
      case 'image_with_content_block':
        return (
          <InfoSection
            Header={fields?.title}
            infoBlocks={fields?.blocks}
            paginationCount={parseInt(fields?.paginationCount)}
            pathName={pathName}
          />
        );

      case 'card_block':
        return (
          <ReferenceCardSection
            header={fields?.title}
            cards={fields?.blocks}
            paginationCount={parseInt(fields?.paginationCount)}
            pathName={pathName}
            link={fields?.link}
          />
        );
      case 'button_with_content':
        return <ButtonWithContentWrapper fields={fields} />;
      case 'product':
        return fields?.type === 'add_to_card' ? (
          <ProductListing fields={fields} />
        ) : (
          <BeyondTheLabel fields={fields} brand={contentfulData?.brand} />
        );
      case 'standard_content_block':
      case 'textBlockWithMobile':
        return <StandardContentBlockWrapper fields={fields} />;
      case 'hero_banner':
      case 'imageBlock':
        return <HeroBannerWrapper bannerContent={fields?.blocks || fields} opacity={fields?.opacity} />;
      case 'nav_tab':
        return <ButtonTabs navTab={fields?.blocks} />;
      case 'breadcrumb':
        return <Breadcrumb fields={fields} />;
      case 'blog_image_content':
        return <BlogImageContent fields={fields} />;
      case 'multiple_blog_image_content':
        return <MultipleBlogImageContent fields={fields} />;
      case 'html_block':
        return (
          <div className="row">
            {fields.blocks.map(block => {
              return (
                <div
                  id="container_iframe"
                  className={block.fields.cssLayout}
                  dangerouslySetInnerHTML={{
                    __html: block.fields.htmlContent,
                  }}
                ></div>
              );
            })}
          </div>
        );
      case 'promo_strip':
        return <PromoStripWrapper fields={fields} />;

      default: {
        return null;
      }
    }
  };

  return (
    <BlogMainContainer>
      {isLoading && <Loader />}
      {contentfulData && (
        <>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type':
                  contentfulData?.section.filter(a => a.fields.module == 'breadcrumb')[0]?.fields.blocks.length >= 2
                    ? 'Article'
                    : 'CollectionPage',
                '@id': '',
                mainEntityOfPage: {
                  '@type':
                    contentfulData?.section.filter(a => a.fields.module == 'breadcrumb')[0]?.fields.blocks.length >= 2
                      ? 'Article'
                      : 'CollectionPage',
                  '@id': '',
                },
                headline: contentfulData?.entryTitle || '',
                datePublished: contentfulData?.banner?.sys?.createdAt,
                dateModified: contentfulData?.banner?.sys?.updatedAt,
                wordCount: 0,
                image: '',
                thumbnailUrl: '',
                articleSection: contentfulData?.entryTitle || '',
                isPartOf: [
                  {
                    '@id': '',
                    url: `${
                      contentfulData?.section
                        .filter(a => a.fields.module == 'breadcrumb')[0]
                        ?.fields.blocks?.slice(-1)[0]?.fields?.url || ''
                    }/${contentfulData?.slug}`,
                    name: contentfulData?.banner?.fields?.internalName,
                    description: contentfulData?.banner?.fields?.title,
                    datePublished: contentfulData?.banner?.sys?.updatedAt,
                    dateModified: contentfulData?.banner?.sys?.updatedAt,
                  },
                ],
              }),
            }}
          />
          <ReactHelmet contentfulData={contentfulData} location={location} />
          <HeroBannerWrapper
            bannerContent={contentfulData?.banner?.fields?.blocks}
            opacity={contentfulData?.banner?.fields?.opacity}
          />
        </>
      )}
      {contentfulData &&
        contentfulData?.section?.length &&
        contentfulData?.section.map(items => {
          return getComponentName(items);
        })}
      <BackToTop />
    </BlogMainContainer>
  );
};

export default HomePage;
